import { Phone, MessageCircle, MapPin, Clock, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const Contact = () => {
  const handleCall = () => {
    window.open('tel:+919256930540');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919256930540?text=Hello! I would like to inquire about room availability at Jungle Villa, Mount Abu.');
  };

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-[#F9F9F7]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="font-sans text-sm tracking-[0.3em] uppercase text-jungle-500 mb-4">
            Get in Touch
          </p>
          <h2
            data-testid="contact-title"
            className="font-serif text-3xl md:text-5xl text-jungle-800 mb-6"
          >
            Contact Us
          </h2>
          <div className="w-20 h-0.5 bg-earth-400 mx-auto" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left - Contact Info */}
          <div className="space-y-8">
            {/* Contact Card */}
            <div className="glass-card rounded-2xl p-8 space-y-6">
              <h3 className="font-serif text-2xl text-jungle-800 mb-6">
                Book Your Stay
              </h3>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  data-testid="contact-call-btn"
                  onClick={handleCall}
                  className="flex-1 bg-jungle-800 hover:bg-jungle-700 text-white rounded-full flex items-center justify-center gap-3 py-6 transition-transform hover:scale-105"
                >
                  <Phone className="w-5 h-5" />
                  <span className="font-sans tracking-wide">Call Now</span>
                </Button>

                <Button
                  data-testid="contact-whatsapp-btn"
                  onClick={handleWhatsApp}
                  className="flex-1 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full flex items-center justify-center gap-3 py-6 transition-transform hover:scale-105"
                >
                  <MessageCircle className="w-5 h-5" />
                  <span className="font-sans tracking-wide">WhatsApp</span>
                </Button>
              </div>

              <p className="text-jungle-600 text-center text-sm">
                Available 24/7 for your inquiries
              </p>
            </div>

            {/* Info Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 rounded-full bg-jungle-100 flex items-center justify-center mb-4">
                  <MapPin className="w-5 h-5 text-jungle-600" />
                </div>
                <h4 className="font-sans font-semibold text-jungle-800 mb-2">Address</h4>
                <p className="text-jungle-600 text-sm leading-relaxed">
                  Jungle Villa & Restaurant<br />
                  Mount Abu, Rajasthan<br />
                  India
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 rounded-full bg-jungle-100 flex items-center justify-center mb-4">
                  <Clock className="w-5 h-5 text-jungle-600" />
                </div>
                <h4 className="font-sans font-semibold text-jungle-800 mb-2">Check-in / Check-out</h4>
                <p className="text-jungle-600 text-sm leading-relaxed">
                  Check-in: 12:00 PM<br />
                  Check-out: 11:00 AM<br />
                  Early/Late available
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm sm:col-span-2">
                <div className="w-12 h-12 rounded-full bg-jungle-100 flex items-center justify-center mb-4">
                  <Mail className="w-5 h-5 text-jungle-600" />
                </div>
                <h4 className="font-sans font-semibold text-jungle-800 mb-2">Email</h4>
                <p className="text-jungle-600 text-sm">
                  vikramsinghabu67@gmail.com
                </p>
              </div>
            </div>
          </div>

          {/* Right - Google Maps */}
          <div className="h-[400px] lg:h-full min-h-[400px] rounded-2xl overflow-hidden shadow-lg">
            <iframe
              data-testid="contact-map"
              title="Jungle Villa Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58583.85012889726!2d72.67759!3d24.59383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395d2a8a8a8a8a8b%3A0x8a8a8a8a8a8a8a8a!2sMount%20Abu%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
